import React from 'react';
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import Card from "@mui/material/Card";
import MDInput from "components/MDInput";
import TextField from '@mui/material/TextField';
import MDButton from "components/MDButton";
import { formatDateDQ } from 'modules/formatDates';
import { getUTCDatesFromTo } from "modules/formatDates";
import { getUTCDatesFromParams } from "modules/formatDates";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
//import axios from "axios";
import Select from '@mui/material/Select';
import DetectorsOverview from '../components/tables/DetectorsOverview';
import MDTypography from "components/MDTypography";
import { getDayRangeISO, getYesterdayDateString } from 'modules/formatDates';
import { getDayStartAndEndISO } from 'modules/formatDates';
import MDDatePicker from "components/MDDatePicker";


const DetectorsList = () => {
    const { t } = useTranslation();

    let now = new Date();
    const [customDate, setCustomDate] = useState(getYesterdayDateString());
    const [customHours, setCustomHours] = useState(2);
    const [hideBody, setHideBody] = useState(true);
    const [showParams, setShowParams] = useState(null);

    const handleCustomDates = (event, newValue) => {
        console.log("event.target.value", event.target.value)
        setCustomDate(event.target.value);
    }


    function applyEnabled() {
        const selectedDate = new Date(customDate);
        selectedDate.setHours(0, 0, 0, 0);
        now.setHours(0, 0, 0, 0);
        return selectedDate < now;
    }
    const apply = () => {
        setHideBody(false);
        let dates = {
            from: "",
            to: ""
        }
        let casted
        casted = getDayStartAndEndISO(customDate)
        dates.from = customDate;
        dates.to = customDate;

        setShowParams({
            detector: "DetectorList",
            dates: dates,
            location: "",
            selectedDetectors: []
        })
    }

    const toYMDLocal = (d) => {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${y}-${m}-${day}`;
    };

    const fromYMDLocal = (s) => {
        if (!s) return null;
        const [y, m, d] = s.split("-").map(Number);
        // build a *local* date; set to noon to avoid DST midnight quirks
        return new Date(y, m - 1, d, 12, 0, 0, 0);
    };


    return (
        <DashboardLayout>
            <Card style={{ marginTop: '3px' }}>
                <div className='rawContainer' >
                    <MDBox p={3} lineHeight={1} style={{ width: '100%' }}>
                        <div className="rawContainerCenteredV" >
                            <Box sx={{ minWidth: 160, marginTop: '20px' }}>
                                <div className='rawContainer'>

                                    <Box sx={{ minWidth: 160, marginLeft: '10px' }}>
                                        <div className='rawDPicker'>
                                            <div className='fromtodp'>
                                                <MDDatePicker
                                                    input={{
                                                        placeholder: "dd/mm/yyyy",
                                                        sx: {
                                                            color: "#344767",
                                                            "&::placeholder": { color: "#eef1f6", opacity: 1 },
                                                            "& input::placeholder": { color: "#eef1f6", opacity: 1 },
                                                            "& .MuiInputBase-input": { color: "#eef1f6" },
                                                        },
                                                    }}
                                                    options={{
                                                        enableTime: false,
                                                        dateFormat: "d/m/Y",
                                                        altFormat: "d/m/Y",
                                                        maxDate: new Date(), // fine; MDDatePicker passes a Date object
                                                    }}
                                                    value={fromYMDLocal(customDate)}  // ✅ local-safe Date or null
                                                    onChange={(selectedDates) => {
                                                        const picked = selectedDates?.[0] ?? null;
                                                        setCustomDate(picked ? toYMDLocal(picked) : ""); // ✅ store local YYYY-MM-DD
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </Box>

                                </div>
                            </Box>
                            {
                                applyEnabled()
                                    ? <MDButton variant="gradient" color="info" style={{ marginTop: '20px' }} onClick={apply}>{t("common.buttons.apply")}</MDButton>
                                    : <div className='halfContainerCenteredV'>
                                        <MDButton variant="gradient" color="info" style={{ marginTop: '20px' }} disabled>{t("common.buttons.apply")}</MDButton>
                                    </div>
                            }
                        </div>
                    </MDBox>
                </div>
            </Card>

            {
                !hideBody
                    ? <Card style={{ marginTop: '3px', padding: '12px', height: '100%' }}>
                        <Grid container item xs={12} md={12}>
                            <Grid container={true} p={2}>
                                <div className='rawContainerDiagrams'>
                                    <div className='diagrammHeadTitle'>{t("dataQuality.detectorsList.heading")}</div>
                                    <DetectorsOverview params={showParams} />
                                </div>
                            </Grid>
                        </Grid>
                    </Card>
                    : <></>
            }

        </DashboardLayout>
    );
};

export default DetectorsList;